/**
 * Expose `xor`
 */

module.exports = xor;

/**
 * XOR utility
 *
 * T T F
 * T F T
 * F T T
 * F F F
 *
 * @param {Boolean} a
 * @param {Boolean} b
 * @return {Boolean}
 */

function xor(a, b) {
  return a ^ b;
}



//////////////////
// WEBPACK FOOTER
// ./~/component-xor/index.js
// module id = 331
// module chunks = 50971735488461